import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';

import * as Sentry from '@sentry/react';
import { isLocalHost } from 'utils/isLocalHost';
import { DocumentMetas } from 'DocumentMetas';
import { store } from './store/store';

import reportWebVitals from './reportWebVitals';
import './config/i18n';
import 'focus-visible/dist/focus-visible';
import './index.css';
import App from './App';
import { VendorProvider } from './store/vendor/VendorProvider';

// setup react query
const queryClient = new QueryClient();

// setup sentry
Sentry.init({
  // enabled: !isLocalHost,
  release: process.env.REACT_APP_VERSION,
  environment: isLocalHost ? 'local' : process.env.REACT_APP_ENV,
  dsn: 'https://d9ebb52733e34ebcbe8154f2b77a8a80@o879385.ingest.sentry.io/6402648',

  integrations: [Sentry.browserTracingIntegration(), new Sentry.Replay()],
  tracesSampleRate: isLocalHost ? 1 : 0.3,
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
});

// add context
Sentry.setContext('vendor', { name: process.env.REACT_APP_VENDOR });

// log version
console.log('version:', process.env.REACT_APP_VERSION);

// render
ReactDOM.render(
  <React.StrictMode>
    <VendorProvider>
      <DocumentMetas />
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <App />
        </Provider>
      </QueryClientProvider>
    </VendorProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
